<template>
  <div class="General">
    <div class="headerGeneralSales">
      <div style="display: flex; gap: 10px">
        <b-button class="BtnRegister" @click="modalHeight">
          <b-icon-plus
            scale="1.5"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-plus>
          <span style="width: 170px">Nova Receita</span>
        </b-button>
        <b-button
          class="BtnRegister"
          v-if="salesSelecteds.length"
          @click.stop="enviarEmLote"
        >
          <b-icon-arrow-right
            scale="1.0"
            style="
              width: 30px;
              background: #006458;
              height: 30px;
              color: white;
              border-radius: 3px;
            "
          ></b-icon-arrow-right>
          <span style="width: 170px">Envio em lote</span>
        </b-button>
      </div>
      <div class="searchContainer">
        <div class="searchInput">
          <b-form-select
            class="searchFilter"
            :style="type === 'situacaoReceita' && 'border-radius: 3px 0 0 3px;'"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="type"
            :options="filterCombobox"
            @change="handleClearInput"
          ></b-form-select>

          <b-form-select
            v-if="type === 'situacaoReceita'"
            class="searchFilter"
            style="border-radius: 0 3px 3px 0"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="prescriptionSituation"
            :options="prescriptionSituationOpts"
            @change="filterSale(page, false, true)"
          ></b-form-select>

          <div v-else>
            <b-input
              class="inputSearch"
              placeholder="Pesquisar por..."
              v-model="textPesquisa"
              @keyup.enter="filterSale(page)"
            ></b-input>
          </div>
        </div>

        <b-form-select
          class="searchFilter"
          style="border-radius: 0 3px 3px 0"
          size="sm"
          value-field="value"
          text-field="text"
          v-model="limitOption"
          :options="limitOptions"
          @change="filterSale(page, false, true)"
        ></b-form-select>

        <div class="lineSearch">
          <div class="summaryMonth">
            Resumo: &nbsp;
            <strong>{{
              selectTextDate === "Personalizado" ? "" : `(${selectTextDate})`
            }}</strong>
          </div>

          <div class="pagMonth"></div>

          <div
            class="searchInput"
            style="
              padding: 0px !important;
              display: flex;
              justify-content: space-between;
            "
            v-if="selectTextDate === 'Personalizado'"
          >
            <button class="btnPeriod" size="sm">Período</button>

            <div class="dateInput">
              <input
                type="date"
                id="date"
                v-model="startDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                  cursor: pointer;
                  border-left: none;
                  width: 120px;
                  border-radius: 0px 5px 5px 0px;
                "
              />
              <input
                type="date"
                id="date"
                v-model="endDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                  cursor: pointer;
                  width: 120px;
                  border-right: none;
                  border-radius: 5px 0 0 5px;
                "
              />
            </div>

            <b-button size="sm" @click="filterSale(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
          </div>

          <div style="width: 25px">
            <DropdownFilters @handleFilterDays="handleFilterDays" />
          </div>
        </div>
      </div>
    </div>
    <div class="headerCounter">
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Rascunho')"
        :style="
          status === 'Rascunho' && 'background-color: transparent; color: black'
        "
      >
        <img
          src="@/assets/file-circle-exclamation-solid-full.svg"
          style="width: 16px; height: 16px; color: gray"
          alt="Rascunho"
        />
        <span>Rascunhos</span>
        <span v-if="!status || status === 'Rascunho'">
          - {{ this.countRascunho }}</span
        >
      </b-button>
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Finalizado(a)')"
        :style="
          status === 'Finalizado(a)' &&
          'background-color: transparent; color: black'
        "
      >
        <img
          src="@/assets/file-circle-check-solid-full.svg"
          style="width: 16px; height: 16px"
          alt="Finalizadas"
        />
        <span>Finalizadas</span>
        <span v-if="!status || status === 'Finalizado(a)'">
          - {{ this.countFinalizado }}</span
        >
      </b-button>
      <b-button
        class="BtnCounter"
        @click="handleTypeSale('Cancelado')"
        :style="
          status === 'Cancelado' &&
          'background-color: transparent; color: black'
        "
      >
        <img
          src="@/assets/file-circle-xmark-solid-full.svg"
          style="width: 16px; height: 16px"
          alt="Canceladas"
        />
        <span>Canceladas</span>
        <span v-if="!status || status === 'Cancelado'"
          >- {{ this.countCancelado }}
        </span>
      </b-button>
    </div>
    <div class="generalContainer">
      <div class="rowProvisionService" v-if="spinGeneral">
        <div class="loadingLazy">
          <div class="loader">
            <span>WINFIT</span>
            <span>WINFIT</span>
          </div>
          <span style="">Buscando Informações...</span>
        </div>
      </div>
      <div class="rowProvisionService" v-else>
        <div class="ContentTable">
          <div class="headerTable">
            <div
              class="celTable"
              style="
                width: 8%;
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 10px;
                padding-left: 10px;
              "
            >
              <input
                type="checkbox"
                style="width: 15px"
                :checked="salesSelecteds.length >= 1"
                @click.stop="selectAllReceitas"
              />
              <div>Status</div>
            </div>
            <div class="celTable" style="width: 6%">Receita</div>
            <div class="celTable" style="width: 7%">NF-e</div>
            <div class="celTable" style="width: 9%">ART/TRT</div>
            <div class="celTable" style="width: 9%">Data</div>
            <div class="celTable" style="width: 28%">Cliente</div>
            <div class="celTable" style="width: 20%">Resp. Técnico</div>
            <div class="celTable" style="width: 15%">Situação</div>
            <!-- <div class="celTable" style="width: 10%">Envio</div> -->
            <div class="celTableActions">Ações</div>
          </div>
          <div
            v-for="dataSearchSale in dataSale"
            :key="dataSearchSale.id"
            :class="`rowSupplier`"
            @click.stop="editSales(dataSearchSale.id)"
          >
            <div
              class="celTable"
              style="
                width: 8%;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                gap: 15px;
                padding-left: 10px;
              "
            >
              <div>
                <input
                  type="checkbox"
                  style="width: 15px"
                  :checked="salesSelecteds.includes(dataSearchSale.id)"
                  @click.stop="
                    salesSelecteds.includes(dataSearchSale.id)
                      ? (salesSelecteds = salesSelecteds.filter(
                          (e) => e != dataSearchSale.id
                        ))
                      : salesSelecteds.push(dataSearchSale.id)
                  "
                />
              </div>
              <img
                :src="getStatusIcon(dataSearchSale.status)"
                style="width: 16px; height: 16px"
                alt="Status"
              />
            </div>

            <div class="celTable" style="width: 6%">
              {{ dataSearchSale.receita }}
            </div>

            <div class="celTable" style="width: 7%">
              {{ dataSearchSale.numeroNFe || "--" }}
            </div>

            <div class="celTable" style="width: 9%">
              {{ dataSearchSale.art }}
            </div>

            <div class="celTable" style="width: 9%">
              {{ dataSearchSale.data | moment }}
            </div>

            <div class="celTable" style="width: 28%">
              {{ dataSearchSale.nomeCliente }}
            </div>

            <div class="celTable" style="width: 20%">
              {{ dataSearchSale.nomeTecnico }}
            </div>

            <div class="celTable" style="width: 15%">
              <div v-if="enviandoReporting === dataSearchSale.id">
                <span style="padding: 10px"><b-spinner small /></span>
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                  gap: 5px;
                "
                @click.stop="
                  dataSearchSale.msgErroEnvioReceita
                    ? openMsgErroReceita(dataSearchSale.msgErroEnvioReceita)
                    : undefined
                "
              >
                <span>
                  <b-icon
                    v-if="dataSearchSale.msgErroEnvioReceita"
                    icon="info-circle-fill"
                    class="text-danger"
                    scale="1.2"
                  ></b-icon>
                </span>

                {{
                  enviandoReporting === dataSearchSale.id
                    ? ""
                    : shippingSituation(dataSearchSale.situacaoReceita)
                }}
              </div>
            </div>

            <div class="celTableActions">
              <div class="btnActions">
                <b-dropdown
                  id="dropdown-1"
                  class="btnActions1"
                  variant="none"
                  size="sm"
                >
                  <template #button-content>
                    <b-icon-gear-fill class="contentActions" />
                  </template>

                  <b-dropdown-item
                    v-if="winfitComleto"
                    @click.stop="
                      handleModalGenerateCompletedSale(dataSearchSale.id)
                    "
                  >
                    Gerar venda completa
                  </b-dropdown-item>

                  <b-dropdown-item
                    @click.stop="printReportSelect(dataSearchSale.id, false)"
                  >
                    Imprimir
                  </b-dropdown-item>
                  <b-dropdown-item @click.stop="printInfoGenrl()">
                    Informações Gerais
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="!dataSearchSale.signedDate && canUseDigitalSignature"
                    @click.stop="
                      handleOpenModalConfirm(
                        dataSearchSale.id,
                        'modal-confirm-sign'
                      )
                    "
                  >
                    Assinar Digitalmente
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="dataSearchSale.signedDate"
                    @click.stop="printReportSelect(dataSearchSale.id, true)"
                  >
                    Imprimir receita assinada
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="dataSearchSale.signedDate && canUseDigitalSignature"
                    @click.stop="openModalCancelSign(dataSearchSale.id)"
                  >
                    Cancelar assinatura digital
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="getCompanyUf === 'ES'"
                    @click.stop="
                      handleSendOrCancelReportES(
                        dataSearchSale.id,
                        dataSearchSale.protocoloES,
                        dataSearchSale.situacaoReceita
                      )
                    "
                  >
                    {{
                      !dataSearchSale.protocoloES &&
                      dataSearchSale.situacaoReceita === "nao_enviada"
                        ? "Enviar E-IDAF"
                        : dataSearchSale.protocoloES &&
                          dataSearchSale.situacaoReceita === "enviada" &&
                          "Cancelar envio E-IDAF"
                    }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="getCompanyUf === 'MT'"
                    @click.stop="
                      handleSendOrCancelReportMT(
                        dataSearchSale.id,
                        dataSearchSale.situacaoReceita
                      )
                    "
                  >
                    {{
                      dataSearchSale.situacaoReceita === "nao_enviada"
                        ? "Enviar SISDEV"
                        : dataSearchSale.situacaoReceita === "enviada" &&
                          "Cancelar envio SISDEV"
                    }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="getCompanyUf === 'SC'"
                    @click.stop="
                      handleSendOrCancelReportSC(
                        dataSearchSale.id,
                        dataSearchSale.situacaoReceita
                      )
                    "
                  >
                    {{
                      ["nao_enviada"].includes(dataSearchSale.situacaoReceita)
                        ? "Enviar Sigen SC"
                        : "Cancelar envio Sigen SC"
                    }}
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="
                      getCompanyUf === 'GO' &&
                      dataSearchSale.situacaoReceita === 'enviada'
                    "
                    @click.stop="
                      handleOpenModalConfirm(
                        dataSearchSale.id,
                        'modal-confirm-sidago'
                      )
                    "
                  >
                    Cancelar envio SIDAGO
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-b-modal.modal-center3
                    v-if="dataSearchSale.status === 'Cancelado'"
                    @click.stop="resusePrescription(dataSearchSale.id)"
                  >
                    Reutilizar numeração
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="dataSearchSale.status !== 'Cancelado'"
                    @click.stop="openModalCancelPrescription(dataSearchSale.id)"
                  >
                    Cancelar
                  </b-dropdown-item>

                  <b-dropdown-item
                    @click.stop="openRetornoEmbalagem(dataSearchSale)"
                  >
                    Retorno Embalagem
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        v-else
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          max-height: 100vh;
          overflow: auto;
          padding: 10px 20px;
          width: 100%;
          max-width: 100%;
        "
      >
        <span style="font-size: 1rem; font-weight: bold; color: gray"
          >Não há dados para exibir ...</span
        >
      </div> -->
    </div>

    <div class="FooterPagination">
      <div class="setBtn">
        <button
          class="itemBtn"
          :disabled="page == 1"
          @click="previousPage(page)"
        >
          <b-icon-chevron-left></b-icon-chevron-left>
        </button>
        <button class="centerItemBtn">{{ page }}</button>
        <button
          class="itemBtn"
          :disabled="this.dataLength < 9"
          @click="nextPage(page)"
        >
          <b-icon-chevron-right></b-icon-chevron-right>
        </button>
      </div>
    </div>
    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalPurchase" @click="modalHeight"> X </b-button>
        <Prescription
          style="margin-top: 30px"
          :typeComponent="'Receita'"
          :isReuse="isReuse"
        />
      </div>
    </div>

    <b-modal
      id="modal-estorno"
      hide-footer
      hide-header
      centered
      size="xl"
      title="estorno"
    >
      <div>
        <div style="position: relative; display: flex; justify-content: center">
          <h6 style="font-weight: bold; text-align: center">
            Produtos da Receita
          </h6>
          <button class="closeEst" @click="$bvModal.hide('modal-estorno')">
            X
          </button>
        </div>
        <div>
          <div
            class="headerTable"
            style="font-size: 12px; justify-content: space-between"
          >
            <div class="celTable" style="width: 10%">Registro</div>
            <div class="celTable" style="width: 30%">Nome</div>
            <div class="celTable" style="width: 30%">Embalagem</div>
            <div class="celTable" style="width: 5%">Qnt.</div>
            <div class="celTable" style="width: 10%">Devolvida</div>
            <div class="celTable" style="width: 100px">A devolver</div>
          </div>
          <div
            v-for="(prod, index) in productsOfEstorno"
            :key="prod.id"
            :class="`rowEstorno`"
          >
            <div class="celTableEst" style="width: 10%">
              {{ prod.registroAgrotox }}
            </div>
            <div class="celTableEst" style="width: 30%">
              {{ prod.nome }}
            </div>

            <div class="celTableEst" style="width: 30%">
              {{ prod.embalagem }}
            </div>

            <div class="celTableEst" style="width: 5%">
              {{ prod.quantidade }}
            </div>
            <div class="celTableEst" style="width: 10%">
              {{ prod.quantDevolvida }}
            </div>
            <div class="number-control" style="width: 80px">
              <div class="number-left" @click="decrementar(index)"></div>
              <input
                type="number"
                name="number"
                disabled
                class="number-quantity"
                v-model.number="estornEmb[index]"
                :max="prod.quantidade"
                min="0"
              />
              <div
                class="number-right"
                @click="incrementar(index, prod.quantidade)"
              ></div>
            </div>
          </div>
        </div>
        <div class="ctnDelAll">
          <button
            class="btnWhiteEst"
            v-if="productsOfEstorno.some((p) => p.quantDevolvida > 0)"
            @click.stop="handleEstornoCompleto()"
          >
            Estornar Retorno Embalagem
          </button>
          <button class="btnWhiteEst" @click.stop="handleImprimir()">
            Imprimir
          </button>
          <button class="btnGreenEst" @click="estornarProdutos">
            Retorno Embalagem
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-excluir"
      hide-footer
      hide-header
      centered
      size="md"
      title="Excluir"
    >
      <div>
        <h6 class="textModalBill">Deseja excluir a Receita?</h6>
        <div class="ctnLoadDelAll" v-if="spinDelete">
          <b-spinner class="spin"></b-spinner>
          <span>Aguarde ...</span>
        </div>
        <div v-else class="ctnDelAll">
          <button
            class="btnContentConfirmedWhiteDelAll"
            @click="$bvModal.hide('modal-excluir')"
          >
            Não, obrigado!
          </button>
          <button class="btnContentConfirmedDelAll">Sim, quero excluir!</button>
        </div>
      </div>
    </b-modal>

    <ModalConfirm
      modalName="modal-confirm-cancel-prescription"
      title="Cancelar Receita ?"
      subtitle="Esta ação irá cancelar a receita. O número da ART poderá ser reutilizado em uma nova emissão. Deseja realmente cancelar?"
      rightButtonText="Sim"
      leftButtonText="Não cancelar"
      :rightButtonClick="cancelPrescription"
    />

    <ModalConfirm
      modalName="modal-confirm-cancel-sign"
      title="Cancelar assinatura da Receita ?"
      subtitle="Esta ação irá cancelar a assinatura receita. Deseja realmente cancelar?"
      rightButtonText="Sim"
      leftButtonText="Não cancelar"
      :rightButtonClick="cancelSign"
    />

    <ModalConfirm
      typeModal="info"
      modalName="modal-confirm-sign"
      title="Assinar Receita Digitalmente"
      subtitle="Deseja assinar digitalmente esta receita?"
      headerIcon="b-icon-patch-exclamation-fill"
      rightButtonText="Cancelar"
      leftButtonText="Assinar Digitalmente"
      :leftButtonClick="handleSignPrescription"
      @modalClosed="selectedPrescriptionId = null"
    />

    <ModalConfirm
      typeModal="info"
      modalName="modal-confirm-sidago"
      title="Cancelamento do envio"
      subtitle="Deseja cancelar o envio desta receita para o SIGADO ?"
      headerIcon="b-icon-patch-exclamation-fill"
      rightButtonText="Não, voltar"
      leftButtonText="Sim, cancelar"
      :leftButtonClick="cancelSentPrescriptionToSidago"
      @modalClosed="selectedPrescriptionId = null"
    />

    <ModalConfirm
      typeModal="info"
      modalName="alert-modal-reports"
      title="Erro ao enviar receita"
      subtitle="Identificamos que ocorreu um problema ao enviar esta receita para o órgão do estado"
      headerIcon="b-icon-patch-exclamation-fill"
      leftButtonText="Fechar"
      :showRightButton="false"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          border-radius: 5px;
          padding: 0.5rem 0 1rem 0;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0.5rem 1.2rem 0 1.2rem;
          "
        >
          <div style="display: flex; gap: 0.6rem; align-items: center">
            <div class="contentAlertIcon">
              <b-icon-info-circle style="color: red" scale="0.9" />
            </div>

            <p
              style="
                margin: 0 0 0 0;
                font-size: 0.8rem;
                font-family: Poppins-Bold, sans-serif !important;
              "
            >
              Corrija os erros abaixo!
            </p>
          </div>

          <p
            style="
              margin: 0;
              background-color: rgb(255 0 0 / 12%);
              border-radius: 50px;
              padding: 0.15rem 0.8rem;
              font-size: 0.65rem;
              color: brown;
            "
          >
            {{ reportErrors.length }} Erros
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 0.8rem;
            overflow: auto;
            width: 100%;
            max-height: 200px;
            padding: 0.2rem 1.2rem 0.6rem 1.2rem;
          "
        >
          <div
            v-for="(errors, idx) in reportErrors"
            :key="idx"
            class="contentReportError"
          >
            <div
              style="
                min-width: 23px;
                min-height: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgb(255 0 0 / 12%);
                border-radius: 50%;
                font-size: 0.68rem;
                color: brown;
              "
            >
              {{ idx + 1 }}
            </div>

            <p
              style="
                margin: 0;
                font-size: 0.75rem;
                color: oklch(44.6% 0.03 256.802);
                font-family: Poppins-Medium, sans-serif !important;
              "
            >
              {{ errors }}
            </p>
          </div>
        </div>
      </div>
    </ModalConfirm>

    <ModalConfirm
      modalName="transform-in-completed-sale"
      title="Converter para Venda Completa?"
      subtitle="A receita será convertida de forma permanente em uma Venda Completa. Esta ação é irreversível e recomendada quando houver emissão de Nota Fiscal. Para desfazer, será necessário cancelar a Venda Completa e refazer a receita. "
      rightButtonText="Não, voltar"
      leftButtonText="Sim, converter"
      typeModal="info"
      headerIcon="b-icon-patch-exclamation-fill"
      :leftButtonClick="() => generateCompletedSale()"
      @modalClosed="selectedPrescriptionId = null"
    />

    <ModalConfirm
      typeModal="info"
      modalName="alert-modal-reports"
      title="Erro ao enviar movimentação"
      subtitle="Identificamos que ocorreu um problema ao enviar essa movimentação para o órgão do estado"
      headerIcon="b-icon-patch-exclamation-fill"
      leftButtonText="Fechar"
      :showRightButton="false"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 0.5rem;
          border-radius: 5px;
          padding: 0.5rem 0 1rem 0;
        "
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 0.5rem 1.2rem 0 1.2rem;
          "
        >
          <div style="display: flex; gap: 0.6rem; align-items: center">
            <div class="contentNewAlertIcon">
              <b-icon-info-circle style="color: red" scale="0.9" />
            </div>

            <p
              style="
                margin: 0 0 0 0;
                font-size: 0.8rem;
                font-family: Poppins-Bold, sans-serif !important;
              "
            >
              Corrija os erros abaixo!
            </p>
          </div>

          <p
            style="
              margin: 0;
              background-color: rgb(255 0 0 / 12%);
              border-radius: 50px;
              padding: 0.15rem 0.8rem;
              font-size: 0.65rem;
              color: brown;
            "
          >
            {{
              reportErrors.length === 1
                ? `${reportErrors.length} Erro`
                : `${reportErrors.length} Erros`
            }}
          </p>
        </div>

        <div
          style="
            display: flex;
            flex-direction: column;
            gap: 0.8rem;
            overflow: auto;
            width: 100%;
            max-height: 200px;
            padding: 0.2rem 1.2rem 0.6rem 1.2rem;
          "
        >
          <div
            v-for="(errors, idx) in reportErrors"
            :key="idx"
            class="contentReportError"
          >
            <div
              style="
                min-width: 23px;
                min-height: 23px;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: rgb(255 0 0 / 12%);
                border-radius: 50%;
                font-size: 0.68rem;
                color: brown;
              "
            >
              {{ idx + 1 }}
            </div>

            <p
              style="
                margin: 0;
                font-size: 0.75rem;
                color: oklch(44.6% 0.03 256.802);
                font-family: Poppins-Medium, sans-serif !important;
              "
            >
              {{ errors }}
            </p>
          </div>
        </div>
      </div>
    </ModalConfirm>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import axios from "axios";
import moment from "moment";
import { DateTime } from "luxon";

import api from "../../services/axios";

import Prescription from "./Prescription.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";
import printReport from "../../reports/sale";
import serviceSale from "../../services/serviceSale";
import serviceSidago from "../../services/serviceSidago";
import DropdownFilters from "../../components/UI/DropdownFilters/DropdownFilters.vue";
import serviceProductSale from "../../services/serviceProductSale";
import { printEstorno } from "../../reports/Products/Estorno";
import { hasDigitalSignaturePermission } from "../../utils/digitalSignaturePermission";

export default {
  components: {
    Prescription,
    ModalConfirm,
    DropdownFilters,
  },
  data() {
    return {
      reportErrors: [],
      salesSelecteds: [],
      selectTextDate: "Este mês",
      year: DateTime.local().year,
      month: DateTime.local(),
      textPesquisa: "",
      type: "",
      status: "",
      startDate: "",
      endDate: "",
      monthSelected: "",
      yearSelected: "",
      prescriptionSituation: "nao_enviada",
      limitOption: "9",
      colapseModal: false,
      spinDelete: false,
      isAdvancedSearch: false,
      modalContainer: "contentModalDisable",
      idPurchaseFromModal: null,
      page: 1,
      dataLength: 0,
      sumPurchase: 0,
      countProducts: 0,
      dataPurchases: {},
      dataDetails: {},
      returnProducts: [],
      dataSale: [],
      dataSupplier: {},
      product: {},
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "cpfCnpj", text: "CPF/CNPJ" },
        { value: "art", text: "ART/TRT" },
        { value: "numeroNFe", text: "Nº NF-e" },
        { value: "clienteCidade", text: "Cidade" },
        { value: "receita", text: "Numero da receita" },
        { value: "clienteUf", text: "Estado" },
        { value: "nomeResponsavel", text: "Responsável" },
        { value: "situacaoReceita", text: "Situação Receita" },
        { value: "", text: "Selecione..." },
      ],
      prescriptionSituationOpts: [
        { value: "enviada", text: "Enviada" },
        { value: "enviada_parcialmente", text: "Enviada Parcialmente" },
        { value: "nao_enviada", text: "Não Enviada" },
        { value: "", text: "Selecione..." },
      ],
      limitOptions: [
        { value: "9", text: "10" },
        { value: "20", text: "20" },
        { value: "50", text: "50" },
      ],
      filterMonth: [
        { value: "1", text: "Janeiro" },
        { value: "2", text: "Fevereiro" },
        { value: "3", text: "Março" },
        { value: "4", text: "Abril" },
        { value: "5", text: "Maio" },
        { value: "6", text: "Junho" },
        { value: "7", text: "Julho" },
        { value: "8", text: "Agosto" },
        { value: "9", text: "Setembro" },
        { value: "10", text: "Outubro" },
        { value: "11", text: "Novembro" },
        { value: "12", text: "Dezembro" },
      ],
      filterYear: [
        { value: "2021", text: "2021" },
        { value: "2022", text: "2022" },
        { value: "2023", text: "2023" },
        { value: "2024", text: "2024" },
        { value: "2025", text: "2025" },
        { value: "2026", text: "2026" },
        { value: "2027", text: "2027" },
        { value: "2028", text: "2028" },
        { value: "2029", text: "2029" },
        { value: "2030", text: "2030" },
        { value: "2031", text: "2031" },
        { value: "2032", text: "2032" },
      ],
      selectedPrescriptionId: null,
      enviandoReporting: null,
      isReuse: false,
      totalcancelado: 0,
      countCancelado: 0,
      countFinalizado: 0,
      countRascunho: 0,
      totalfinalizado: 0,
      totalrascunho: 0,
      spinGeneral: false,
      winfitComleto: false,
      productsOfEstorno: [],
      receiptForEstorno: {},
      estornEmb: [],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "SET_DATA_SEARCH_FROM_SALE",
      "ALTER_TYPE_DOCUMENT",
      "SET_HTML_TO_PRINT",
      "SET_ID_TRANSFORM_COMPLETED_SALE",
    ]),

    async enviarEmLote() {
      await api.post("/sales/bulk-sales/send/report", {
        ids: this.salesSelecteds,
      });

      this.$toast.open({
        message: "Envio em lote realizado com sucesso!",
        type: "success",
      });
    },

    openMsgErroReceita(msg) {
      this.reportErrors = [msg];
      this.$bvModal.show("alert-modal-reports");
    },

    async selectAllReceitas() {
      if (this.salesSelecteds.length >= 1) {
        this.salesSelecteds = [];
        return;
      }

      const ids = this.dataSale
        .filter((e) => e.situacaoReceita === "nao_enviada")
        .map((e) => e.id);

      this.salesSelecteds = ids;
    },
    async cancelSign() {
      if (!this.canUseDigitalSignature) return;

      await api.get(`/sales/cancell/sign/${this.prescriptionId}`);

      this.$toast.open({
        message: "Assinatura cancelada com sucesso!",
        type: "success",
      });

      await this.filterSale(1);
    },

    async openModalCancelSign(id) {
      if (!this.canUseDigitalSignature) return;

      this.prescriptionId = id;

      this.openModals("modal-confirm-cancel-sign");
    },

    async openModalCancelPrescription(id) {
      this.prescriptionId = id;

      this.openModals("modal-confirm-cancel-prescription");
    },

    async openRetornoEmbalagem(receipt) {
      this.receiptForEstorno = receipt;
      this.productsOfEstorno = await serviceProductSale.findByIdSale(
        receipt.id
      );
      this.estornEmb = this.productsOfEstorno.map(
        (prod) => prod.quantDevolvida || 0
      );

      this.openModals("modal-estorno");
    },

    incrementar(index, maxQuantity) {
      if (this.estornEmb[index] < maxQuantity) {
        this.$set(this.estornEmb, index, this.estornEmb[index] + 1);
      }
    },

    decrementar(index) {
      if (this.estornEmb[index] > 0) {
        this.$set(this.estornEmb, index, this.estornEmb[index] - 1);
      }
    },

    async estornarProdutos() {
      const produtosParaAtualizar = this.productsOfEstorno
        .map((prod, index) => {
          const novaQuantidadeDevolvida = Number(this.estornEmb[index]) || 0;

          if (
            novaQuantidadeDevolvida > 0 &&
            novaQuantidadeDevolvida !== prod.quantDevolvida
          ) {
            return {
              ...prod,
              quantDevolvida: novaQuantidadeDevolvida,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      if (produtosParaAtualizar.length === 0) {
        this.$bvModal.hide("modal-estorno");
        return;
      }

      try {
        await api.put(
          `/products-of-sale/update/and/print`,
          produtosParaAtualizar
        );

        printEstorno(this.receiptForEstorno.id);
        this.$bvModal.hide("modal-estorno");
      } catch (error) {
        console.error("Erro ao estornar produtos:", error);
      }
    },
    async handleEstornoCompleto() {
      try {
        const products = await serviceProductSale.findByIdSale(
          this.receiptForEstorno.id
        );

        const produtosZerados = products.map((prod) => ({
          ...prod,
          quantDevolvida: 0,
        }));

        await api.put(`/products-of-sale/update/and/print`, produtosZerados);

        this.productsOfEstorno = produtosZerados;
        this.$toast.open({
          message: "Estorno realizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.error("Erro ao estornar o retorno das embalagens:", error);
      }
    },

    handleImprimir() {
      if (typeof printEstorno === "function") {
        printEstorno(this.receiptForEstorno.id);
      }
    },
    async cancelPrescription() {
      try {
        if (this.prescriptionId) {
          await serviceSale.cancel(this.prescriptionId);
          await this.filterSale(1);
          this.$toast.open({
            message: "Receita cancelada!",
            type: "success",
          });
        }
      } catch (error) {
        const message =
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message;

        this.$toast.info(message || "Erro ao emitir a receita.");
      }
    },

    handleClearInput() {
      if (this.type !== "status") {
        this.textPesquisa = "";
      }
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";
      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_SALE({});
      }

      await this.filterSale(1);
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
    },

    async filterSale(page, byStatus, bySituation) {
      if (this.selectTextDate === "Personalizado") {
        if (this.startDate && this.endDate) {
          const start = DateTime.fromISO(this.startDate);
          const end = DateTime.fromISO(this.endDate);
          const diffInMonths = end.diff(start, "months").months;

          if (diffInMonths > 6) {
            this.$toast.open({
              message:
                "Atenção! Período superior a 6 meses.Para esse intervalo, utilize o módulo Relatórios.",
              type: "info",
            });
            return;
          }

          if (end < start) {
            this.$toast.open({
              message: "A data final não pode ser anterior à data inicial",
              type: "warning",
            });
            return;
          }
        }
      }

      try {
        this.spinGeneral = true;

        if (!byStatus) this.status = "";

        if (!bySituation) this.prescriptionSituation = "";

        const { data } = await api.get(
          `/sales?q=${this.textPesquisa}&type=${this.type}&status=${this.status}&situacaoReceita=${this.prescriptionSituation}&page=${page}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=Receita&limit=${this.limitOption}`
        );

        if (!Object.keys(data).length) {
          return;
        }

        this.dataLength = data.data.length;
        this.dataSale = data.data;
        if (data.totals && Object.keys(data.totals).length) {
          this.countCancelado = data.totals.countCancelado;
          this.countFinalizado = data.totals.countFinalizado;
          this.countRascunho = data.totals.countRascunho;
          this.countFaturado = data.totals.countFaturado;

          this.totalcancelado = data.totals.cancelado;
          this.totalfinalizado = data.totals.finalizado;
          this.totalrascunho = data.totals.rascunho;
          this.totalFaturado = data.totals.faturado;
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      switch (valueDate) {
        case "hoje":
          this.startDate = today.toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "esteMes":
          this.startDate = today.startOf("month").toSQLDate();
          this.endDate = today.endOf("month").toSQLDate();
          break;
        case "ontem":
          // eslint-disable-next-line no-case-declarations
          const yesterday = today.minus({ days: 1 });
          this.startDate = yesterday.toSQLDate();
          this.endDate = yesterday.toSQLDate();
          break;
        case "7dias":
          this.startDate = today.minus({ days: 7 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "30dias":
          this.startDate = today.minus({ days: 30 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "mesPassado":
          // eslint-disable-next-line no-case-declarations
          const lastMonth = today.minus({ months: 1 });
          this.startDate = lastMonth.startOf("month").toSQLDate();
          this.endDate = lastMonth.endOf("month").toSQLDate();
          break;
        case "ultimos3meses":
          this.startDate = today
            .minus({ months: 3 })
            .startOf("month")
            .toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        default:
          break;
      }

      await this.filterSale(1);
    },

    handleTypeSale(name) {
      this.status = name;

      this.filterSale(1, true);
    },

    getStatusIcon(status) {
      const icons = {
        Rascunho: require("@/assets/file-circle-exclamation-solid-full.svg"),
        "Finalizado(a)": require("@/assets/file-circle-check-solid-full.svg"),
        Cancelado: require("@/assets/file-circle-xmark-solid-full.svg"),
      };
      return icons[status] || icons["Rascunho"];
    },

    getTotal(dataPurchase) {
      return dataPurchase.reduce(
        (total, purchase) => total + purchase.valorTotal,
        0
      );
    },

    async editSales(tableRowData) {
      const data = await this.searchTableDataForSale(tableRowData);
      if (data && Object.keys(data).length) {
        this.handleEditSale(data);
      }
    },

    async searchTableDataForSale(idVenda) {
      try {
        const { data } = await api.get(
          `/sales/${idVenda}?typeProduct=agrotoxicos`
        );
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },
    handleEditSale(data) {
      this.SET_DATA_SEARCH_FROM_SALE(data);

      const nameDocument = "venda";
      this.ALTER_TYPE_DOCUMENT(nameDocument);
      this.modalHeight();
    },

    async resusePrescription(id) {
      await this.editSales(id);
      await this.$nextTick();
      this.isReuse = !this.isReuse;
    },

    async sendReport(id) {
      this.enviandoReporting = id;

      try {
        await serviceSale.sendReport(id);

        this.$toast.success("Relatório enviado com sucesso.");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = Array.isArray(msg) ? msg : [];
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async cancelReport(id) {
      this.enviandoReporting = id;

      try {
        await serviceSale.cancelReport(id);

        this.$toast.success("Cancelamento da receita enviado!");
      } catch (err) {
        if (axios.isAxiosError(err)) {
          let msg = err?.response?.data?.messageErrors ?? [];

          this.reportErrors = Array.isArray(msg) ? msg : [];
        }
      } finally {
        this.enviandoReporting = null;
        if (this.reportErrors.length) {
          this.$bvModal.show("alert-modal-reports");
        }
      }
    },

    async handleSendOrCancelReportES(id, protocoloES, situacaoReceita) {
      this.enviandoReporting = id;
      this.reportErrors = [];

      if (!protocoloES && situacaoReceita === "nao_enviada")
        await this.sendReport(id);
      else if (protocoloES && situacaoReceita === "enviada")
        await this.cancelReport(id);

      if (this.reportErrors.length) {
        await this.filterSale(this.page);
      }

      this.enviandoReporting = null;
    },

    async handleSendOrCancelReportMT(id, situacaoReceita) {
      this.enviandoReporting = id;
      this.reportErrors = [];

      if (situacaoReceita === "nao_enviada") await this.sendReport(id);
      else if (situacaoReceita === "enviada") await this.cancelReport(id);

      if (this.reportErrors.length) {
        await this.filterSale(this.page);
      }
      this.enviandoReporting = null;
    },

    async handleSendOrCancelReportSC(id, situacaoReceita) {
      this.enviandoReporting = id;
      this.reportErrors = [];

      if (situacaoReceita === "nao_enviada") await this.sendReport(id);
      else if (
        situacaoReceita === "enviada" ||
        situacaoReceita === "enviada_parcialmente"
      )
        await this.cancelReport(id);

      if (this.reportErrors.length) {
        await this.filterSale(this.page);
      }
      this.enviandoReporting = null;
    },

    printReportReceipt(idSale) {
      printReport("receiptStandard", idSale);
    },

    printInfoGenrl() {
      printReport("printInfo");
    },

    async printReportSelect(idSale, toSign) {
      try {
        if (!idSale) return;

        const sale = this.dataSale.find(({ id }) => id === idSale);
        if (toSign && !sale?.signedDate && !this.canUseDigitalSignature) {
          return this.$toast.info(
            "Este usuário não tem permissão para assinatura digital"
          );
        }

        const result = await printReport("receiptStandard", idSale, toSign);

        if ("url" in result && toSign) {
          const { data } = await axios.get(`${result.url}?v=${Date.now()}`, {
            responseType: "blob",
          });

          const blob = new Blob([data], { type: "application/pdf" });

          const pdfUrl = URL.createObjectURL(blob);

          this.SET_HTML_TO_PRINT(pdfUrl);
        } else {
          this.SET_HTML_TO_PRINT("html" in result ? result.html : result.url);
        }

        if (result.messageErrors && result.messageErrors.length) {
          this.reportErrors = Array.isArray(result.messageErrors)
            ? result.messageErrors
            : [];
          this.$bvModal.show("alert-modal-reports");
        }

        await this.filterSale(this.page);
      } catch (error) {
        return this.$toast.info(
          error?.response?.data?.message ||
            "Ocorreu um problema ao realizar a impressão!"
        );
      }
    },

    async handleFilterSale(typeStatus) {
      this.type = "status";
      this.textPesquisa = typeStatus;

      await this.filterSale(this.page);
    },

    async handleSignPrescription() {
      if (!this.canUseDigitalSignature) return;

      try {
        await this.printReportSelect(this.selectedPrescriptionId, true);

        await this.filterSale(this.page);
      } catch (err) {
        return this.$toast.info(
          "Ocorreu um problema ao assinar a receita digitalmente"
        );
      }
    },

    async cancelSentPrescriptionToSidago() {
      try {
        await serviceSidago.cancel(this.selectedPrescriptionId);

        await this.filterSale(this.page);

        this.$toast.success(
          "Cancelamento da receita ja enviada para o SIDAGO realizado!"
        );
      } catch (err) {
        return this.$toast.info(
          "Ocorreu um problema ao cancelar o envio da receita para o SIDAGO!"
        );
      }
    },

    nextPage() {
      this.filterSale((this.page += 1), true);
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    handleOpenModalConfirm(prescriptionId, modalName) {
      this.selectedPrescriptionId = prescriptionId;
      this.$bvModal.show(modalName);
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSale((this.page -= 1));
      }
    },

    shippingSituation(shippingType) {
      const types = {
        enviada: "Enviada",
        enviada_parcialmente: "Enviada Parcialmente",
        nao_enviada: "Não Enviada",
      };

      return types[shippingType];
    },

    handleModalGenerateCompletedSale(prescriptionId) {
      this.selectedPrescriptionId = prescriptionId;
      this.openModals("transform-in-completed-sale");
    },

    async generateCompletedSale() {
      this.SET_ID_TRANSFORM_COMPLETED_SALE(this.selectedPrescriptionId);

      await serviceSale.updateTypeOrder(
        this.selectedPrescriptionId,
        "Receita Pedido"
      );

      this.$router.push("/vendas");
    },

    delayToOpen() {
      setTimeout(() => {
        this.openModalVenda();
      }, 500);
    },
  },

  async mounted() {
    this.monthSelected = this.month.month;
    this.yearSelected = this.year;
    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();
    await this.filterSale(1);

    this.winfitComleto = localStorage.getItem("winfitCompleto") === "true";
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      idTransformCompletedSale: (state) => state.idTransformCompletedSale,
      dataCompany: (state) => state.dataCompany,
    }),
    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },
    getCompanyUf() {
      return this.dataCompany?.uf?.toUpperCase() || "";
    },
    canUseDigitalSignature() {
      return hasDigitalSignaturePermission("novaReceita");
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  async created() {
    this.ALTER_SIZE_MODAL("disable");

    if (
      this.$route.query.origem === "inspecao" &&
      (this.$store.state.dataSearchFromSale.idInspecao ||
        this.$store.state.dataSearchFromSale.inspectionId)
    ) {
      await this.$nextTick();
      await this.modalHeight();
    }

    // Gambiarrinha para quando o cliente estiver na tela de movimentações de agrotóxico e clicar em 'Abrir receita'
    if (this.idTransformCompletedSale) {
      await this.editSales(this.idTransformCompletedSale);
      this.SET_ID_TRANSFORM_COMPLETED_SALE(null);
    }
  },
};
</script>
<style scoped>
.General {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
}
.headerGeneralSales {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 65px;
  background: white;
  border-radius: 7px;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.headerCounter {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 5px;
  margin: 5px 0;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnCounter {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.BtnCounter:hover {
  background: #e3ebe2;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.Summary {
  display: flex;
  flex-direction: column;
  width: 30%;
  gap: 10px;
  justify-content: flex-start;
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.iconItem:hover {
  background: #006256;
  cursor: pointer;
}

.ItemSummarySales {
  height: 60px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummarySales span {
  font-size: 13px;
  cursor: context-menu;
  letter-spacing: 1px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}
.ContainerBtn {
  width: 30%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 70px 0px 0px 22px;
}

.Btn {
  width: 100%;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 14px;
  letter-spacing: 1px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}

.ItemSummary {
  width: 30%;
  height: 55px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummary span {
  font-size: 14px;
  cursor: context-menu;
  letter-spacing: 1px;
}

.lineSearch {
  display: flex;
  align-items: center;
  padding: 0px 0px 5px 0px;
}

.searchByMonth {
  width: 30%;
  display: flex;
  align-items: center;
  margin: 10px 0px 10px 20px;
  border-radius: 5px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.searchMonth {
  width: 100px;
  height: 30px;
  border-radius: 5px 0px 0px 5px;
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchMonth:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

/* ALERT MODAL */

.containerAlertModal {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 0.5rem;
}

.btnCloseAlertModal {
  width: 22px;
  height: 22px;
  position: absolute;
  right: -5px;
  top: -5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff000021;
  border-radius: 5px;
  box-shadow: 0 0 0 1px #a52a2a6b;
  transition: ease-in all 0.1s;
  cursor: pointer;
}

.btnCloseAlertModal:hover {
  background-color: #ff00005d;
  transition: ease-in all 0.1s;
}

.contentAlertIcon {
  width: 25px;
  min-width: 25px;
  height: 25px;
  min-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255 0 0 / 12%);
  border-radius: 8px;
}

.contentReportError {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 8px;
  background-color: white;
  box-shadow: rgb(222, 222, 222) 0px 0px 3px 1px;
  padding: 0.5rem 0.5rem;
  gap: 0.5rem;
}

.contentBtnsAlertModal {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.contentBtnsAlertModal button {
  width: 100%;
  outline: none !important;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.357);
  border: none !important;
  border-radius: 5px;
  padding: 0.3rem 1rem !important;
  font-size: 0.83rem;
  background-color: white;
  transition: ease-in all 0.1s;
  height: 40px;
  font-family: Poppins-Medium, sans-serif !important;
}

.contentBtnsAlertModal button:hover {
  background-color: whitesmoke;
  transition: ease-in all 0.1s;
}

.btnContinueWhitouthEmb {
  height: 40px;
  background-color: white;
  transition: ease-in all 0.1s;
  margin: 0;
  font-size: 0.83rem;
  font-family: Poppins-Medium, sans-serif !important;
  color: oklch(0.446 0.03 256.802);
}

.btnContinueWhitouthEmb:hover {
  color: black;
  background-color: oklch(0.446 0.03 256.802);
}

.btnSpeakInWhatsApp {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.7rem;
  height: 40px;
  background-color: #25d366 !important;
  transition: ease-in all 0.1s;
  color: white;
}

.btnSpeakInWhatsApp p {
  margin: 0;
  font-size: 0.8rem;
  font-family: Poppins-Medium, sans-serif !important;
}

.btnSpeakInWhatsApp:hover {
  background-color: #20b757 !important;
}

/* ALERT MODAL */

.searchYear {
  width: 50px;
  height: 30px;
  border-radius: 0px 5px 5px 0px;
  border: 1px solid rgb(195, 193, 193);
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchYear:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select3 {
  left: 4px;
  -moz-appearance: none;
  appearance: none;
  background: none;
  font-weight: bold;
  padding: 0 !important;
}

.ctnDelAll {
  padding-top: 20px;
  display: flex;
  justify-content: space-around;
}

.ctnLoadDelAll {
  padding-top: 20px;
  display: flex;
  font-size: 14px;
  gap: 20px;
  flex-direction: column;
  align-items: center;
}

.textModalBill {
  font-weight: bold;
  width: 95%;
  text-align: center;
}

.btnContentDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 33%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentWhiteDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 33%;
  height: 28px;
  position: relative;
  color: #006256;
  background: #eff0f0;
}

.btnContentConfirmedDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 43%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentConfirmedWhiteDelAll {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 43%;
  height: 28px;
  position: relative;
  color: #006256;
  background: #eff0f0;
}
.btnGreenEst {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnWhiteEst {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 30%;
  height: 28px;
  position: relative;
  color: #006256;
  background: #eff0f0;
}
.closeEst {
  position: absolute;
  right: -10px;
  top: -10px;
  border: none;
  background: rgb(216, 216, 216);
  border-radius: 4px;
  color: rgb(255, 153, 0);
}
.Arrows {
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.Arrows:hover {
  background: whitesmoke;
}

.searchFilter {
  width: 140px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  font-family: Poppins-Regular, sans-serif !important;
}
.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
  color: #2e2e2e;
  display: flex;
  align-items: center;
}
.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.searchFilterSituation {
  width: 230px;
  border-left: none !important;
  height: 30px;
  border-radius: 0 5px 5px 0 !important;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  position: relative !important;
}

.searchFilterSituation:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.custom-select {
  left: 4px;
  position: relative;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
}
.inputSearch {
  width: 200px;
}

.textRegister {
  font-weight: bold;
  padding-left: 20px;
}

.searchInput {
  display: flex;
  justify-content: center;
}

.searchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 10px;
}
.searchInputDate {
  width: 40%;
  display: flex;
}
.searchAvancedContent {
  display: flex;
  padding: 3px 0px 3px 0;
  align-items: center;
  justify-content: flex-end;
}

.searchAvanced {
  justify-content: center;
  color: #3a4750;
  font-size: 12px;
  height: 30px;
  gap: 10px;
  padding: 0px 20px;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAvanced:hover {
  background: rgb(205, 205, 205);
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  padding: 0 10px;
  border: 1px solid #e3e0e0;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 0rem 1.5rem;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 0px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #e3e0e0;
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

.generalContainer {
  display: flex;
  flex-direction: column;
  padding: 0px;
  width: 100%;
  max-width: 100%;
}

.rowProvisionService {
  height: 100%;
}

.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  gap: 10px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 35px;
  gap: 10px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}
.rowEstorno {
  width: 100%;
  display: flex;
  align-items: center;
  background: #ebebeb;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 4px;
  text-align: center;
  height: 35px;
  gap: 1px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
  padding: 10px;
  justify-content: space-between;
}
.loadingLazy {
  position: absolute;
  top: 50%;
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* spinner */
.loader {
  position: relative;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.3px #006458;
}

.loader span:nth-child(2) {
  color: #006458;
  -webkit-text-stroke: 1px #006458;
  animation: loading 3s ease-in-out infinite;
}

@keyframes loading {
  0%,
  100% {
    clip-path: polygon(
      0% 30%,
      15% 54%,
      32% 50%,
      54% 60%,
      70% 61%,
      84% 69%,
      100% 32%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      16% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.celTableEst {
  display: flex;
  flex-direction: column;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 1px solid #c3c3c3;
}

.celTableActions {
  width: 8%;
  display: flex;
  gap: 3px;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 25px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}

.btnActions {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #709e8a;
  border-radius: 5px;
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: white;
}

.borderSale {
  border-left: solid 10px green;
}

.borderBudget {
  border-left: solid 10px rgb(0, 81, 169);
}

.borderBoxFront {
  border-left: solid 10px rgb(64, 59, 116);
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.ContentTableModal {
  display: flex;
  flex-direction: column;
  padding: 10px 20px 0 20px;
  width: 100%;
}

tr:nth-child(even) {
  background: #f1f1f1;
}

td {
  text-transform: capitalize;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.FooterPagination {
  display: flex;
  align-items: center;
  height: 50px;
  padding: 20px;
  width: 100%;
  justify-content: flex-end;
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  gap: 10px;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  cursor: auto;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalPurchase {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalPurchase:hover {
  background: whitesmoke;
  color: red;
}

.closeModalPurchase:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.rowModal {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}
.borderInput {
  font-size: 14px;
  height: 30px;
  border: none;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 15px;
  padding-right: 4px;
  color: #5c5855;
  background: #ffffff;
}

.borderInput:focus {
  border: none;
}

.input-group {
  width: 30%;
}

.input-group-supplier {
  width: 45%;
  position: relative;
}

.input-group-key {
  width: 100%;
  position: relative;
}

.user-label {
  position: absolute;
  left: 5px;
  font-size: 11px;
  z-index: 30;
  bottom: 23px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconCopy {
  position: absolute;
  right: 30px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: rgb(0, 0, 0);
  height: 30px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}

.form-control:focus {
  background-color: #ffffff;
  box-shadow: none !important;
}
.number-control {
  display: flex;
  align-items: center;
  position: relative;
}

.number-left::before,
.number-right::after {
  content: attr(data-content);
  background-color: #006256;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  width: 20px;
  height: 30px;
  color: white;
  transition: background-color 0.3s;
  cursor: pointer;
}
.number-left {
  position: absolute;
  left: 0px;
  border-radius: 8px 0 0 8px;
  background-color: #006256;
}
.number-right {
  position: absolute;
  right: 0px;
  border-radius: 0 8px 8px 0;
  background-color: #006256;
}
.number-left::before {
  content: "-";
}

.number-right::after {
  content: "+";
}

.number-quantity {
  padding: 0.25rem;
  padding-left: 1.5rem;
  border: 0;
  width: 70px;
  text-align: center;
  border: 1px solid rgb(122, 122, 122);
}

.number-left:hover::before,
.number-right:hover::after {
  background-color: #006256;
}

.form-control {
  display: block;
  width: 230px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  height: 30px;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.typeSale {
  color: #403b74;
  font-weight: bold;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .General {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }
  .ContainerBtn {
    width: 100%;
    padding: 0px;
    margin: 70px 0px 0px 8px;
  }
  .Btn {
    width: 33%;
    height: 30px;
    font-size: 11px;
  }
  .searchByMonth {
    width: 35%;
    margin: 10px 0px 10px 8px;
  }
  .month {
    font-size: 11px;
  }
  .lineSearch {
    padding: 0px;
  }
  .Summary {
    padding-bottom: 10px;
  }
  .ItemSummary {
    width: 32%;
    height: 50px;
    gap: 0px;
  }
  .searchAll {
    font-size: 11px;
    width: 70px;
  }
  .searchFilter {
    width: 100px;
  }
  .textRegister {
    margin: 10px 10px 0px 0px;
    padding-left: 0px;
  }
  .textRegister span {
    padding-left: 5px;
  }
  .searchInput {
    margin: 10px 10px 0px 0px;
  }
  .ContentTable {
    padding: 10px 10px 0 0px;
  }
  .inputSearch {
    width: 50%;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }
  .itemBtn {
    width: 18px;
    height: 18px;
  }
  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
  .FooterPagination {
    padding: 0px;
  }
}

@media screen and (max-width: 700px) {
  .General {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    width: 100% !important;
    height: 100vh;
    font-size: 10px;
  }

  .ContainerBtn {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
    margin: 60px 0px 0px 0px;
  }

  .ContentTable {
    height: auto;
    padding: 10px 10px 0 10px;
  }

  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }

  .searchInput {
    display: flex;
    margin: 0px;
    width: 100%;
    flex-direction: column;
  }

  .Btn {
    width: 80%;
    height: 30px;
  }

  .searchByMonth {
    width: 80%;
    display: flex;
    align-items: center;
    margin: 10px 0px;
  }

  .lineSearch {
    display: flex;
    align-items: center;
    padding: 0px 0px 5px 0px;
    justify-content: center;
  }

  .ItemSummary {
    width: 32%;
    height: 80px;
    gap: 0px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
  }
}
</style>
